<div *ngIf="!operation">
  <span class="spinner">
    Loading...
  </span>
</div>
<div class="clr-row" *ngIf="operation">
  <app-ax-operation-summary class="clr-col-md-12" [operation]="operation" [simplifiedDisplay]="simplifiedDisplay"></app-ax-operation-summary>
</div>
